import type { TableRow } from "@prequel/shared-components";

import type { ProductResource } from "@/api/import/products";
import { useListProducts } from "@/api/import/products";
import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";

const COLUMNS = ["Name", "Destinations", "Created"];

const mapProductToRow = (product: ProductResource): TableRow => ({
  id: product.id,
  to: `/import/destinations/products/${product.id}`,
  cells: [
    { value: product.name },
    { value: product.destinations.length },
    { value: <Timestamp timestamp={product.created_at} /> },
  ],
});

const ProductsTable = () => {
  return (
    <ResourceTable<ProductResource>
      columns={COLUMNS}
      useQuery={useListProducts}
      rowMapper={mapProductToRow}
      emptyMessage="No products configured."
    />
  );
};

export default ProductsTable;
